import { createSelector } from "@ngrx/store";
import { selectAdminEntities } from "./admins.reducer";

export const selectAdmins = createSelector(selectAdminEntities, (adminEntities) =>
	Object.values(adminEntities).sort((a, b) => a.firstname.localeCompare(b.firstname))
);
